export default (isProxy: boolean = true) => {
    if (process.env.STORYBOOK) {
        return '/mockData';
    }

    switch (process.env.ENV) {
        case 'prod':
        case 'rel':
            // 團it 育凱 開發環境 需要拿掉travel 才可以測試
            // 所以這裡會判斷 <div id="removeTravelLevel"></div>(育凱加上的)
            // 代表要移除 travel 的路徑
            return document.getElementById('removeTravelLevel') ? '' : '/travel';

        // bbc 版本需要多一層 /travel

        // if 是要藉由 proxy 抓取 IT API，則不用傳參數
        // else 不須需要 proxy，要在本機上直接連到 u 機
        //      例如點擊 本機 <a> 標籤，要導到 u 機的產品頁，則傳入 false
        default:
            return isProxy ? '/lionbbcagent' : '//lionbbcagent.ubbc.liontravel.com';
    }
};
